import { config } from '../config';

export const EnvHeader: React.FC = () => {
    return config.Env === 'production' ? null : <div className="environment-header">{config.Env}</div>;
};
